import React from 'react'
import {ajax, Status, getState, subscribe, unsubscribe, getBrand, arrayFrom} from '../../twd'

const state = getState('corporates.yield-grids', {
    method: 'HIGHEST',
    rating: 'INVESTMENT_GRADE'
})

export default () => {
    const [method, setMethod_] = React.useState(state.value.method || 'HIGHEST')
    const setMethod = React.useCallback((m) => {
        state.set({method:m})
        setMethod_(m)
    }, [])

    const [rating, setRating_] = React.useState(state.value.rating || 'INVESTMENT_GRADE')
    const setRating = React.useCallback((m) => {
        state.set({rating:m})
        setRating_(m)
    }, [])

    const [grids, setGrids] = React.useState([])
    const [status, setStatus] = React.useState(Status.LOADING)
    const lastAbort = React.useRef()
    const [ts,setTs] = React.useState(Date.now())

    React.useEffect(() => {

        setGrids([])
        ;(async () => {
            try {
                setStatus(Status.LOADING)

                let gridType = rating==='INVESTMENT_GRADE'
                    ? 'CORPORATES_INVESTMENT_GRADE'
                    : 'CORPORATES_HIGH_YIELD'
                let {data, abort} = await ajax({
                    url:'/esb/retailservice/yieldGridService/getYieldGridDataByType',
                    method: 'POST',
                    params: {
                        brand: 'etrade' || getBrand(),
                        yieldGridTypeList: [{
                            gridType,
                            yieldType: method
                        }]
                    }
                })

                lastAbort.current = abort
                let x = await data
                lastAbort.current = null

                let t = method==='HIGHEST' ? 'Highest Yield' : 'Average Yield'
                let r = rating==='INVESTMENT_GRADE' ? 'Investment Grade' : 'High Yield'
                let rs = arrayFrom(x[0].tables)
                    .map(a => Object.assign(a, {table:t, rating:r}))
                setGrids(rs)

                setStatus(Status.LOADED)
            } catch(e) {
                if (lastAbort.current) lastAbort.current()
                setStatus(Status.FAILED_TO_LOAD)
            }

        })()

        return () => {
            if (lastAbort.current) lastAbort.current()
        }

    }, [method, rating, ts])

    React.useEffect(() => {
        let subId = subscribe('atmosphere_reconnected.corporates_yield_grids', ({ts}) => {
            setTs(ts)
        })
        return () => {
            unsubscribe(subId)
        }
    }, [])

    return { method, setMethod, rating, setRating, grids, status }
}
